module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "part-1-chapter-3"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "part-1-chapter-3-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Chapter 3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "part-1-chapter-3-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("A")]), _vm._v(" year later Paul became an associate in an office with freshly painted white walls, new furniture and carpets, and pictures on the walls. Smart wooden shutters replaced the shabby blinds.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Two years later Ralph asked him, ‘Do you like Cobar?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What do you like about it?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘The genuine and friendly people and a real sense of community. Everybody knowing who you are and saying hello when they see you in the street or in a shop.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Do you like it enough to stay permanently?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Too right I do.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How about a full partnership then?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Paul held out his hand. ‘I accept. Thanks.’")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("In January 2014 they received an e-mail from an accountant who lived in South Kensington in London.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("Dear Messrs McLachlan and Knight,")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("Tordorrach")])])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("I am purchasing the above property. Would you act on my behalf and do the conveyancing, please?")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("Yours sincerely,")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("Noël Carlyle")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("‘You can deal with him,’ Ralph said to Paul. ‘You’re used to city dwellers.’ His tone was scathing.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You make them sound like undesirables, Uncle Ralph.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Where’s Tordorrach?’ Paul asked.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘A two-hour drive from here. Most of the road is unsealed. It’s been up for sale for over four years.  It is – or was – a sheep and wheat station.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Was?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘The sheep died in the drought and the wheat crops failed.’ He got onto the estate agent’s website. ‘Take a look.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The photos of the seventy-thousand acre property made the state of the homestead clear. It was falling down. The red earth was dry and there was scarcely any grass.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Good news for Seamus,’ said Ralph.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Surely no one lives in that house?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No. Seamus Ryan can’t afford the maintenance. He and his wife live in a caravan. They’ve got no electricity, and their phone was cut off years ago. The poor wretches are heavily in debt. But Seamus has made some stupid mistakes. He’s an infuriating bloke. You’ll see that when you meet him.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Why would anyone from England want to buy this place?’ asked Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Why not?’ asked Linda.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ll show you.’ They swapped seats and Paul looked up Noël Carlyle’s address on Google Earth. As he’d anticipated it was a large white house with five floors. There was no front garden and just a small back garden with gravel paths and bushes.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Tiny,’ said Linda. ‘What’s good about it?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’ll be big inside,’ said Paul. ‘And see the garden in the middle of the square – it’s for the residents of the square only. The gate will have a key.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Linda wrinkled her nose. ‘Big deal.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘If Noël Carlyle owns the whole house he’s rich,’ Paul told them. ‘Even if it’s divided into flats and he just owns the basement or the attic flat he’ll be well off.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ralph looked puzzled. ‘How come?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Have you ever been to England?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Hell no. I’ve never lived anywhere except here – apart from when I was at school and uni.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Paul smiled. ‘That part of London is exclusive. My house here would cost less than a garage there.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’re kidding!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He typed ‘Rightmove’ in the search engine and watched their expressions of bemusement when small mews houses in Bayswater and Knightsbridge came up with prices beyond two million pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘That’s four million dollars, isn’t it?’ said Linda.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Paul nodded and typed South Kensington in the location. A five-storey house had a price tag of twenty-four million pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ralph stared wide-eyed at the computer screen. ‘Are my eyes going funny? Twenty-four million dollars?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Not twenty-four million dollars.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He looked alarmed. ‘My eyes are going funny?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Pounds. Twenty-four million pounds. Forty-eight million dollars.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ralph shook in head. ‘This whole town wouldn’t go for that much! Why does someone that rich want to buy Tordorrach?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Maybe he doesn’t own it – he might just rent it,’ said Linda.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Paul typed ‘rent’ instead of ‘buy’ in the preferences.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ralph looked even more amazed. ‘Ten thousand pounds a month?’ he said slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Paul couldn’t help laughing at their incredulity. ‘Yep. Twenty thousand dollars.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Why? Why does anyone want to live in London, let alone pay those crazy prices?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s got a lot – cinemas, theatres, museums, two opera houses –’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Bah – opera,’ scoffed Ralph. ‘Who wants to listen to that rubbish? A whole lot of women squawking and dying.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I like opera.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ralph shook his head. ‘You were always going on about some bloke – Wagging?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Wagner.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Have you ever been to London?’ Linda asked.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I lived there for two years. It’s an enthralling city.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How could you afford it?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I didn’t live in a place like that. I rented an overcrowded, damp flat, with four friends.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘And you call that “enthralling”? You need help.’ Ralph looked at the copy of the e-mail. ‘Surely accountants don’t earn that much?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘He might have inherited the house. His parents or grandparents might have bought it years ago, before property prices soared. How long has Seamus Ryan owned Tordorrach?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘His father was the manager for Edward Halland, the previous owner who ran it with his son Charles. If things had gone the way they should have, Charles would be the owner now. By all accounts the place was in a prime state and profitable when it was sold to the Ryans in 1982.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Why did they sell it?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Two things happened. First Charles’s wife walked out – wrote letters for him and their two little girls and just left. She had post-natal depression. That was a terrible blow for all of them. Then Charles was bitten by a snake – he died. His parents sold it to the Ryans and moved to Bowral. They took their granddaughters with them.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How old were they?’ Linda wanted to know. ‘The daughters I mean.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Eight and six.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Poor little things,’ she said.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc5f6dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part-001-chapter-003.vue
// module id = 87
// module chunks = 0